import { Component } from '@angular/core';

import { HeaderComponent } from '../header/header.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-default-layout',
  imports: [RouterModule, HeaderComponent],
  templateUrl: './default-layout.component.html',
})
export class DefaultLayoutComponent {}
